import { Controller } from "react-hook-form"
import { useRef } from "react"
import Close from "@/common/icons/close"
import LogoSpinner from "@/components/common/loading/logo-spinner"
import classNames from "classnames"
import styles from "./search-control.module.css"

export const SearchControl = ({
  className,
  control,
  name,
  onReset,
  onSubmit,
  placeholder,
  isLoading,
  required = false
}) => {
  const elemRef = useRef(null)

  return (
    <Controller
      {...{ control, name }}
      rules={{ required: required ? "Detta fält är obligatoriskt" : false }}
      render={({ field }) => {
        const hasValue = field.value && field.value.length > 0

        return (
          <div
            className={classNames(styles.controller, className, {
              "has-value": hasValue
            })}
            ref={elemRef}>
            <input
              type="text"
              name={name}
              id={name}
              value={field.value}
              placeholder={placeholder || "Sök"}
              onChange={(value) => field.onChange(value)}
            />
            {hasValue && (
              <div className="clear-search" onClick={() => onReset(name)}>
                <Close />
              </div>
            )}
            <button
              type="button"
              onClick={(e) => onSubmit(e)}
              aria-label="Sök"
              className={classNames({ "is-loading": isLoading })}>
              {!isLoading && <span>Sök</span>}
              {isLoading && <LogoSpinner className="spinner" />}
            </button>
          </div>
        )
      }}
    />
  )
}
